import { render, staticRenderFns } from "./coachesList.vue?vue&type=template&id=1823cac5"
import script from "./coachesList.vue?vue&type=script&lang=js"
export * from "./coachesList.vue?vue&type=script&lang=js"
import style0 from "./coachesList.vue?vue&type=style&index=0&id=1823cac5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports